import { useBankingConsents } from '~/services/consents';
import { isConsentVisibleToUser } from '~/utils/consents';

export const useVisibleBankingConsents = () => {
  const consentsQuery = useBankingConsents();
  const consents = consentsQuery.data ?? [];

  return {
    consentsQuery,
    visibleConsents: consents.filter(isConsentVisibleToUser),
  };
};
